import axios from "axios";

const MAIN_API_URL = process.env.REACT_APP_API_BASE_URL;
export const getGreenEnergyTransactionsData = (prosumerId: number, year: number, month: number, meterType: number) => {
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/transactions/overview?year=${year}&month=${month}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    }).catch(error => {
      console.log(error)
    });
};

export const getGreenAttributeTracking = (prosumerId: number, date: string, secondDate: string, period: string, meterType: number) => {
  console.log(date, secondDate)
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/transactions/tracking?date=${date}&secondDate=${secondDate}&period=${period}&meterType=${meterType}`)
    .then((response) => {
      console.log(response)
      return response.data;
    });
};

export const getGreenAttributeDistributionData = (prosumerId: number, meterType: number) => {
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/transactions/usage?meterType=${meterType}`)
    .then((response) => {
      console.log(response)
      return response.data;
    });
};

export const getProductionData = (prosumerId: number, date: string, period: string, meterType: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/consumptions/production?period=${period}&date=${date}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    });
};

export const getOutstandingBillData = (prosumerId: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/consumptions/outstandingInvoices?payment=0`)
    .then((response) => {
      return response.data;
    });
};

export const getPaidBillsData = (prosumerId: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/consumptions/invoice?payment=1`)
    .then((response) => {
      return response.data;
    });
};

export const getTransactionsData = (prosumerId: number, date: string, meterType: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/consumptions/summary-per-day?date=${date}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    });
};

export const getTransactionChartData = (prosumerId: number, date: string, period: string, meterType: number) => {

  //`${API_URL}/consumer/${consumerId}/consumptions/breakdown?period=${period}&date=${date}&meterType=${meterType}`
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/consumptions/transaction/chart?period=${period}&date=${date}&meterType=${meterType}`)
    .then((response) => {
      return response.data;
    });
};

export const getProductionDashboardData = (prosumerId: number, date: string, period: string, premiseIds: number[]) => {
  return axios
    .get(`${MAIN_API_URL}/prosumer/${prosumerId}/production-dashboard-data?period=${period}&date=${date}&premiseIds=${premiseIds}`)
    .then((response) => {
      return response.data;
    });
};
